import React from 'react'
import DeliveryDetailComponent from '../../@b_components/delivery_detail/delivery_detail.component'
import deliveryData from '../../data/static/delivery.data'

const DeliverySectionContainer = function () {
  return (
    <>
      {deliveryData.map(each => {
        return <DeliveryDetailComponent key={each.id} {...each} />
      })}
    </>
  )
}

export default DeliverySectionContainer
